export default "__VITE_ASSET__K0d7Xv_kmrg9pjrMnixeoA__ 480w, __VITE_ASSET__Jhiobz1iAIl42UC3k5$exQ__ 745w";